import { render, staticRenderFns } from "./ListTableHeaderInvestment.vue?vue&type=template&id=79ba8e7a&scoped=true&"
import script from "./ListTableHeaderInvestment.vue?vue&type=script&lang=js&"
export * from "./ListTableHeaderInvestment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ba8e7a",
  null
  
)

export default component.exports